import Application from "../../Application";
import { UserPreferences } from "../../common/Constants";
import { ICredentialService } from "../../service/credential/CredentialService";
import PasswordResetPresenter, {
  IPasswordResetPresenter
} from "../../presenter/authentication/PasswordResetPresenter";
import PasswordResetCredentials, {
  TPasswordResetCredentials
} from "../../model/authentication/PasswordResetCredentials";

export default class ShowPasswordResetInteractor {
  private application: Application;
  private output?: IPasswordResetPresenter;
  private credentialService: ICredentialService;

  constructor({
    application,
    credentialService
  }: {
    application: Application;
    credentialService: ICredentialService;
  }) {
    this.application = application;
    this.credentialService = credentialService;
  }

  execute() {
    this.output = PasswordResetPresenter({
      application: this.application,
      initialState: {
        languageCode: UserPreferences.DEFAULT_LANGUAGE,
        credentials: PasswordResetCredentials({} as TPasswordResetCredentials)
      }
    });

    this.credentialService.getLanguage().then((languageCode) => {
      this.application.container.registerValue(
        "language",
        languageCode || UserPreferences.DEFAULT_LANGUAGE
      );
      this.output?.setLanguageCode(
        languageCode || UserPreferences.DEFAULT_LANGUAGE
      );
    });

    return this.output;
  }
}
